import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import Calendar from './utils/Calendar';
import CalendarLegend from './utils/CalendarLegend';
import { SelectDueDateContainer } from './subcomponents';
import triggerChangePaymentDueDateAnalytics from '../../helpers/trigger-change-payment-due-date-analytics';
import { PAGE_NAME } from '../../const/analytics';
const SelectDueDate = ({ currentDueDay, eligibleDueDays, handleSelectDay, selectedDay }) => {
    useEffect(() => {
        triggerChangePaymentDueDateAnalytics({
            pageName: PAGE_NAME.START
        });
    }, []);
    return (_jsxs(SelectDueDateContainer, { "data-testid": "select-due-date", children: [_jsx(Calendar, { currentDueDay: currentDueDay, eligibleDueDays: eligibleDueDays, selectedDay: selectedDay, onSelectDay: handleSelectDay }), _jsx(CalendarLegend, {})] }));
};
export default SelectDueDate;
